module.exports = __webpack_public_path__ + "static/heroImg-14c3068e4a3aba9a3b93a7d6a954d7f1.png";